var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import { View, Platform } from 'react-native';
import theme from '../../theme';
const Overlay = styled((_a) => {
    var { theme, device } = _a, rest = __rest(_a, ["theme", "device"]);
    return <View {...rest}/>;
}) `
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  position: ${({ device }) => (device === 'web' ? 'fixed' : 'absolute')};
  opacity: 0.7;
  background-color: ${theme.BlackColor};
`;
Overlay.defaultProps = {
    device: Platform.OS,
    theme: {
        BrighteGreen: theme.BrighteGreen,
        thirtyPT: theme.thirtyPT,
        fifteenPT: theme.fifteenPT,
        hunredThirtyPT: theme.hunredThirtyPT,
        BlackColor: theme.BlackColor,
    },
};
export default Overlay;
